import { Injectable } from '@angular/core';
import { ConfirmationEditionModalComponent, ConfirmationModalComponent } from '@core-lib/components';
import { AppConstants } from '@core-lib/config';
import { ActionType, SensOperation } from '@core-lib/enums';
import { getTiersLabel } from '@core-lib/functions';
import { IAction, IAutocompleteData, IConfirmModalConfig, ITiers } from '@core-lib/models';
import { ModalService } from '@core-lib/modules/modal-container';
import { take } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ConfirmationService {
	maxlengthNomEmetteurRetrait = AppConstants.MAX_LENGHT_NOM_EMETTEUR_RETRAIT;
	maxlengthNomEmetteur = AppConstants.MAX_LENGHT_NOM_EMETTEUR;

	constructor(private modalService: ModalService) {}

	openConfirmationModal(config: IConfirmModalConfig, onConfirm?: () => void, onClose?: () => void): void {
		const modalRef = this.modalService.show(ConfirmationModalComponent, {
			ignoreBackdropClick: true,
			class: config?.modalOptions?.class ?? 'modal-lg',
			keyboard: false
		});

		const confirmationComponent = modalRef.content as ConfirmationModalComponent;
		confirmationComponent.config = config;

		confirmationComponent.action.pipe(take(1)).subscribe((action: IAction) => {
			if (action.type === ActionType.Confirm) {
				modalRef?.hide();
				onConfirm?.();
			} else if (action.type === ActionType.Close) {
				modalRef?.hide();
				onClose?.();
			}
		});
	}

	openEditionConfirmationModal(downloadToken: string, confirmAction: () => void, config: IConfirmModalConfig = null): void {
		const modalRef = this.modalService.show(ConfirmationEditionModalComponent, {
			ignoreBackdropClick: true,
			class: 'modal-md'
		});

		const component = modalRef.content as ConfirmationEditionModalComponent;
		component.downloadToken = downloadToken;
		component.confirmAction = confirmAction;
		component.config = config;
	}

	/**
	 * Fiche de Tiers : Revoir la longueur de certains champs, modal pour alerté l'utilisateur
	 * @param tiers 
	 */
	public showNomEmetteurFromTiersLongModal(sensOpe: SensOperation, tiers?: ITiers | IAutocompleteData, onConfirm?: () => void): void {
		if (!tiers){
			onConfirm?.();
			return;
		} 

		let nomEmetteurDisplayed: string = getTiersLabel(tiers);

		let maxLength = sensOpe == SensOperation.Debit ? this.maxlengthNomEmetteurRetrait : this.maxlengthNomEmetteur;
		if (nomEmetteurDisplayed.length > maxLength) {
			setTimeout(() => {
				const config: IConfirmModalConfig = {
							canConfirm: false,
							textsKey: 'OperationForms.LibelleNomEmetteurLong',
							bodyParams: { nbrCaracteres: maxLength },
							cancelBtnText: 'Actions.Close',
							modalOptions: {
								class: 'modal-md'
							}
						  };
						this.openConfirmationModal(config, null, onConfirm);
			}, 200);
		}else{
			onConfirm?.();
		}
	}
}
